/**
 * ItemsGrid - Grid display of bucket list items with empty state
 */
import { Button } from "@/components/ui/button";
import { Plus, Star } from "lucide-react";
import BucketItemCard from "@/components/BucketItemCard";

const ItemsGrid = ({
  items,
  searchQuery,
  currentUserId,
  partnerId,
  onToggleComplete,
  onEdit,
  onDelete,
  onHide,
  onShare,
  onSummary,
  onItinerary,
  onTravelSearch,
  onBudget,
  onPhotos,
  onComments,
  onPacking,
  onSocialShare,
  onAddItem,
  rankColor,
  rankSolidColor,
  rankBorderColor,
}) => {
  if (items.length === 0) {
    return (
      <div className="empty-state bg-card rounded-2xl border border-charcoal/5 shadow-card">
        <div className="empty-state-icon">
          <Star className="w-12 h-12 text-accent" />
        </div>
        <h3 className="font-serif text-2xl font-medium text-foreground mb-2">
          {searchQuery ? "No matching items" : "Start Your Adventure"}
        </h3>
        <p className="text-muted-foreground mb-6 max-w-sm">
          {searchQuery 
            ? "Try a different search term"
            : "Add your first bucket list item and begin your journey together"
          }
        </p>
        {!searchQuery && (
          <Button
            onClick={onAddItem}
            className="bg-primary text-white hover:bg-primary/90 rounded-full px-8 btn-press"
            data-testid="empty-state-add-btn"
          >
            <Plus className="w-5 h-5 mr-2" />
            Add Your First Dream
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="pb-4 lg:pb-0">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 stagger-children">
        {items.map((item) => (
          <BucketItemCard
            key={item.id}
            item={item}
            currentUserId={currentUserId}
            partnerId={partnerId}
            onToggleComplete={onToggleComplete}
            onEdit={onEdit}
            onDelete={onDelete}
            onHide={onHide}
            onShare={onShare}
            onSummary={onSummary}
            onItinerary={onItinerary}
            onTravelSearch={onTravelSearch}
            onBudget={onBudget}
            onPhotos={onPhotos}
            onComments={onComments}
            onPacking={onPacking}
            onSocialShare={onSocialShare}
            rankColor={rankColor}
            rankSolidColor={rankSolidColor}
            rankBorderColor={rankBorderColor}
          />
        ))}
      </div>
    </div>
  );
};

export default ItemsGrid;
